import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import LeftNav from "../common/leftnav";
import { Link } from "react-router-dom";

const Notification = () => {
  const [emails, setEmails] = useState({
    daily: ["olivia@royalcyber.com", "olivia@royalcyber.com"],
    instant: ["olivia@royalcyber.com"],
    voicemail: ["olivia@royalcyber.com"],
  });
  const [isEditing, setIsEditing] = useState(false);
  const [newEmails, setNewEmails] = useState({
    daily: "",
    instant: "",
    voicemail: "",
  });
  const [showNewEmailInput, setShowNewEmailInput] = useState({
    daily: false,
    instant: false,
    voicemail: false,
  });
  const [emailErrors, setEmailErrors] = useState({
    daily: "",
    instant: "",
    voicemail: "",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setNewEmails({ daily: "", instant: "", voicemail: "" });
    setShowNewEmailInput({ daily: false, instant: false, voicemail: false });
    setEmailErrors({ daily: "", instant: "", voicemail: "" });
  };

  const handleSaveClick = () => {
    // Validate emails
    const newEmailErrors = { daily: "", instant: "", voicemail: "" };
    let isValid = true;

    Object.keys(emails).forEach((type) => {
      emails[type].forEach((email) => {
        if (!validateEmail(email)) {
          newEmailErrors[type] = "Invalid email address";
          isValid = false;
        }
      });
    });

    if (!isValid) {
      setEmailErrors(newEmailErrors);
      return;
    }

    // Save the changes (you can add your save logic here)
    setIsEditing(false);
    setShowNewEmailInput({ daily: false, instant: false, voicemail: false });
  };

  const handleAddEmail = (type) => {
    if (newEmails[type].trim() !== "" && validateEmail(newEmails[type])) {
      setEmails((prevEmails) => ({
        ...prevEmails,
        [type]: [...prevEmails[type], newEmails[type]],
      }));
      setNewEmails((prevNewEmails) => ({ ...prevNewEmails, [type]: "" }));
      setEmailErrors((prevEmailErrors) => ({ ...prevEmailErrors, [type]: "" }));
    } else {
      setEmailErrors((prevEmailErrors) => ({
        ...prevEmailErrors,
        [type]: "Invalid email address",
      }));
    }
  };

  const handleEmailChange = (type, index, value) => {
    setEmails((prevEmails) => {
      const updatedEmails = [...prevEmails[type]];
      updatedEmails[index] = value;
      return { ...prevEmails, [type]: updatedEmails };
    });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <div className="d-flex">
      <LeftNav />
      <div className="dashboard-content flex-grow-1 p-4 bg-light">
        <h3 className="fs-five-title fw-bold mb-4">Notification Settings</h3>

        <div className="card p-4 mb-4 border-light-subtle shadow-sm bg-light-subtle rounded-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <h5 className="fw-bold fs-two mb-0">
                <img
                  src="/assets/bell-blue.svg"
                  alt="Icon"
                  className="img-fluid me-2"
                />
                Recipient Details
              </h5>
            </div>
            {!isEditing && (
              <Button
                variant="link"
                className="text-decoration-none"
                onClick={handleEditClick}
              >
                <img
                  src="/assets/edit-blue.svg"
                  alt="Icon"
                  className="img-fluid me-2 pb-1"
                />
                <Link className="purple-color text-decoration-none fw-bold">
                  Edit
                </Link>
              </Button>
            )}
          </div>

          <p className="text-muted my-2">
            Get notified as soon as a new call comes in. Add or change
            recipients at any time.
          </p>

          <hr className="border-dark-subtle" />

          {/* Email Sections */}
          {["daily", "instant", "voicemail"].map((type) => (
            <div key={type} className="my-2">
              <h6 className="fw-bold">
                {type.charAt(0).toUpperCase() + type.slice(1)} call summary
                destinations
              </h6>
              {emails[type].map((email, index) => (
                <div key={index} className="d-flex align-items-center mb-2">
                  <img
                    src="/assets/mail.svg"
                    alt="Icon"
                    className="img-fluid me-2"
                  />
                  {isEditing ? (
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) =>
                        handleEmailChange(type, index, e.target.value)
                      }
                      className="me-2"
                    />
                  ) : (
                    <p className="text-muted mb-0">{email}</p>
                  )}
                </div>
              ))}
              {isEditing && (
                <>
                  {showNewEmailInput[type] && (
                    <div className="d-flex align-items-center mb-2">
                      <img
                        src="/assets/mail.svg"
                        alt="Icon"
                        className="img-fluid me-2"
                      />
                      <Form.Control
                        type="email"
                        value={newEmails[type]}
                        onChange={(e) =>
                          setNewEmails((prevNewEmails) => ({
                            ...prevNewEmails,
                            [type]: e.target.value,
                          }))
                        }
                        placeholder="Add new email"
                        className="me-2"
                      />
                      <Button
                        className="border-purple-color fw-bold"
                        variant="primary"
                        onClick={() => handleAddEmail(type)}
                      >
                        Add
                      </Button>
                    </div>
                  )}
                  <Link
                    className="text-decoration-none purple-color fw-bold"
                    onClick={() =>
                      setShowNewEmailInput((prevShowNewEmailInput) => ({
                        ...prevShowNewEmailInput,
                        [type]: true,
                      }))
                    }
                  >
                    {emailErrors[type] && (
                      <p className="text-danger fs-one mb-2">
                        {emailErrors[type]}
                      </p>
                    )}
                    +Add
                  </Link>
                </>
              )}
            </div>
          ))}

          {isEditing && (
            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="secondary"
                className="me-4"
                onClick={handleCancelClick}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSaveClick}>
                Save changes
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notification;
